<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading"/>
    <div v-else>
      <div class="no_left_content">
        <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">Add network </h5>
        <div class="vm_checkout_content">
          <div class="vm_checkout_left">
            <div class="mb-3">
              <label for="kt_platform" class="col-form-label">VM Server</label>
              <select class="form-select" id="kt_platform" v-model="form.server_id">
                <option v-for="(cloudServer, index) in cloudServers" :key="'kt_platform_'+index"
                        :value="cloudServer.id">
                  {{ cloudServer.host_name }}
                </option>
              </select>
              <v-errors :errors="errorFor('kt_platform')"></v-errors>
            </div>
            <div class="mb-3">
              <label for="server_region_id" class="col-form-label">Assignable IP</label>
              <input type="text" class="form-control" :value="availableIp?.available_ip" readonly>
            </div>
            <div class="mb-3">
              <label for="billing_type" class="col-form-label">Billing type</label>
              <select class="form-select" v-model="form.billing_type" id="billing_type">
                <option value="monthly">Monthly</option>
                <option value="hourly">Hourly</option>
              </select>
              <v-errors :errors="errorFor('billing_type')"></v-errors>
            </div>
          </div>
          <div class="vm_checkout_right">
            <div class="vm_checkout_right_wrap">
              <h5 class="common_subtitle">Estimated Bill </h5>
              <div class="checkout_right_inner">
                <div class="d_flex_btwn inner_title">
                  <span>Network details</span>
                  <span v-if="form.billing_type == 'monthly'">￦ 5,000</span>
                  <span v-else>￦ 7</span>
                </div>
                <div class="checkout_subtotal">
                  <template v-if="form.billing_type == 'monthly'">
                    <p class="mb_5">Total estimated bill(1 month)</p>
                    <h2 class="subtotal">￦ 5,000</h2>
                  </template>
                  <template v-else>
                    <p class="mb_5">Total estimated bill(1 hour)</p>
                    <h2 class="subtotal">￦ 7</h2>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d_flex_end custom_border_top mt_20 pt_20 pb_20">
        <button type="button" class="btn btn-outline-danger mr_5" @click.prevent="cancelOperation()">Cancel</button>

        <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading"
                @click.prevent="submit"
        >
          Launch
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";

export default {
  name: 'vlan-cloud-network-form',
  components: {LoaderMaskComponent},
  data() {
    return {
      lyLoading: false,
      form: {
        server_id: '',
        billing_type: 'hourly',
      },
      cloudServers: [],
      availableIp: null,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo'
    }),
  },
  mounted() {
    this.loadServers()
  },
  methods: {
    loadServers(){
      this.lyLoading = true
      this.axios.get('/vlan-proxmox-cloud-servers')
          .then(({data}) => {
            this.cloudServers = data.data
            if(this.cloudServers.length > 0){
              this.form.cloud_server_id = this.cloudServers[0].id
            }
            this.loadAvailableIpList()
          })
          .finally(() => {
            this.lyLoading = false
          })
    },
    loadAvailableIpList(){
      this.axios.get('/proxmox/available-ip-list')
          .then(({data}) => {
            console.log(data)
            this.availableIp = data
          })
    },
    cancelOperation() {
      this.$swal({
        title: 'Are you sure want to cancel?',
        text: "It will stop network creation!",
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('cloud-networks');
        }
      });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      this.axios.post(`/proxmox/configure-vm-network/${this.form.server_id}`, this.form)
          .then((response) => {
            if (response.data.success) {
              this.showSuccessMsg(response.data.message);
              this.$router.push('cloud-networks');
            } else {
              this.$swal({
                text: response.data.message,
                showCancelButton: false,
                confirmButtonText: 'Close!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
              })
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
  }
}
</script>
<style scoped>

</style>
  